export default {
  id: 'LoginPage',
  code: 'CN',
  text: {
    'Log In to ClassTopBase': '登录 ClassTopBase',
    'Forgot Your Password?': '忘记你的密码？',
    'Register New Account': '注册新账户',
    'Sign In': '登录',
    'EASY SOLUTION': '轻松管理',
    'FOR YOUR SCHOOL MANAGEMENT': '您所有的学校事务',
    'show': '显示',
    'hide': '隐藏',
    'Resend in {counterTime}s': '重新发送 ({counterTime})s',
    'Send Code': '发送验证码',
    'Unexpected errors': '操作失败',
    'The Phone No./Password combination is not valid': '用户名或密码错误',
    'Password has to be at least 6 characters long': '密码长度至少为六位',
    'User already exists': '用户已存在',
    'Invalid verification code': '验证码错误',
    'Verification code is expired': '验证码已过期',
    'You have used the free trial': '您已经使用过体验版',
    'Phone Number': '手机号',
    'Verification Code': '验证码',
    'Password': '密码',
    'At least 6 characters': '至少6个字符',
    'Email': '邮箱',
    'Or': '或',
    '4 digits': '4位数字',
    'Sign up to ClassTopBase': '注册ClassTopBase账号',
    'Register': '注册',
  }
}
  


// WEBPACK FOOTER //
// ./src/containers/pages/Login/locale.js